<template>
	<div class="feedback-form">
		<div class="box">
			<div class="title">反馈描述</div>
			<div class="form">
				<textarea class="textarea" v-model="context" placeholder="有想法，那就告诉我们吧~"></textarea>
				<div class="count pos">
					{{wordCount}}/{{MAX_WORD_COUNT}}
				</div>
			</div>
			<div class="title">上传图片<span class="count num">({{picCount}}/{{MAX_PIC_COUNT}})</span></div>
			<file-upload v-model="picUrlList" class="uploader"/>
		</div>
		<VanButton class="btn" @click="onClickSubmit">提交反馈</VanButton>
	</div>
</template>

<script>
import FileUpload from "../../../components/file-upload/index";
let MAX_PIC_COUNT = 4;
let MAX_WORD_COUNT = 200;
export default {
	name: 'FeedbackForm',
	components: {FileUpload},
	data() {
		return {
			MAX_PIC_COUNT,
			MAX_WORD_COUNT,
			context: '',
			picUrls: '',
			submitting: false,
			picUrlList: []
		};
	},
	computed: {
		wordCount() {
			return this.getWordCount(this.context || '');
		},
		picCount() {
			return (this.picUrls || '').split(',').filter(p => !!p).length;
		}
	},
	watch: {
		picUrlList: {
			handler(list) {
				this.picUrls = (list || []).filter(item => item.status === 'success').map(item => item.url).join(',');
			}
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.context = '';
			this.picUrls = '';
		});
	},
	methods: {
		getWordCount(str = '') {
			return str ? str.length : 0;
		},
		onClickSubmit() {
			if (this.submitting) {
				return;
			}
			if (!this.context.trim()) {
				this.$toast('请输入内容');
				return;
			}
      let uploading = false
      for(let i = 0; i < this.picUrlList.length;i++) {
        const item = this.picUrlList[i]
        if(item.status === 'uploading') {
          uploading = true
          break
        }
      }
      if (uploading) {
				this.$toast('图片正在上传中，请稍后提交');
        return
      }
			this.submitting = true;
			this.$UserService.submitFeedback({
				context: this.context,
				picUrls: this.picUrls
			}).then(() => {
				this.$toast('提交成功');
				this.$emit('submit');
				this.submitting = false;
			}).catch(() => {
				this.$toast('提交失败');
				this.submitting = false;
			});
		}
	}
};
</script>

<style scoped lang="scss">
	.feedback-form {
		.box {
			background: #ffffff;
			padding: 10px 14px;
			border-radius: 12px;
			margin: 10px;
			padding: 0 14px;
		}
		.title {
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 16px;
			color: #000000;
			line-height: 22px;
			padding: 23px 0 13px 0;
		}
		.form {
			position: relative;
		}
		.textarea {
			width: 327px;
			height: 90px;
			background: #F6F7FC;
			border-radius: 8px;
			border: none;
			outline: none;
			resize: none;
			position: relative;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 16px;
			color: #000000;
			line-height: 22px;
			padding: 12px;
			&::placeholder {
				color: #999999;
			}
		}
		.pos {
			position: absolute;
			bottom: 12px;
			right: 12px;
		}
		.count {
			text-align: right;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 16px;
			color: #999999;
			line-height: 22px;
		}
		.num {
			color: #666666;
		}
		.btn {
			width: calc(100% - 28px);
			height: 48px;
			background: linear-gradient( 90deg, #00A7FD 0%, #006EFA 100%);
			border-radius: 25px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 18px;
			color: #FFFFFF;
			line-height: 25px;
			margin: 10px 14px 0 14px;
		}
		.uploader {
			padding: 0;
			::v-deep .van-uploader__upload {
				width: 70px!important;
				height: 70px!important;
				margin-bottom: 14px;
				border-radius: 8px;
				background: #F6F7FC;
			}
			::v-deep .van-uploader__preview-image {
				width: 70px!important;
				height: 70px!important;
				border-radius: 8px;
			}
			::v-deep .van-uploader__preview-delete {
				border-radius: 0 8px 0 4px;
			}
			::v-deep .van-uploader__mask {
				border-radius: 8px;
			}
		}
	}
</style>
